import { render } from "./Reference.vue?vue&type=template&id=a342af1c&scoped=true"
import script from "./Reference.vue?vue&type=script&lang=js"
export * from "./Reference.vue?vue&type=script&lang=js"

import "./Reference.vue?vue&type=style&index=0&id=a342af1c&lang=scss&scoped=true"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a342af1c"]])

export default __exports__